const projects = [];
function ProjectObject() {
	this.projectTitle = "";
	this.projectText = "";
	this.imgSrc = "";
	this.projectTags = [];
	this.projectVideos = [];
	this.award = [];
}

let amazonCxLabs = new ProjectObject();
amazonCxLabs.projectTitle = "Amazon Alexa Series";
amazonCxLabs.projectText = "Editor / Motion Graphics";
amazonCxLabs.imgSrc = "images/amazonCxLabs.jpg";
amazonCxLabs.projectTags = [
	"corporate",
	"comedy",
	"amazon alexa series",
	"favorites",
	"awards",
];
amazonCxLabs.projectVideos = [
	"697988340",
	"665866362",
	"665865169",
	"668871862",
	"668872252",
	"668872593",
	"582369174",
	"582369670",
	"569695873",
	"555046250",
	"555045189",
	"555047791",
];
amazonCxLabs.award = ["tellyAwardGold"];
projects.push(amazonCxLabs);

//___________________________________________________________________________________

let agent47 = new ProjectObject();
agent47.projectTitle = "Hitman: Agent 47";
agent47.projectText = "Editor";
agent47.imgSrc = "images/agent47.jpg";
agent47.projectTags = [
	"action",
	"Hitman: Agent 47",
	"trailers",
];
agent47.projectVideos = ["209509693"];
projects.push(agent47);

//___________________________________________________________________________________

let assassinsCreed = new ProjectObject();
assassinsCreed.projectTitle = "Assassins Creed";
assassinsCreed.projectText = "Editor";
assassinsCreed.imgSrc = "images/assassinsCreed.jpg";
assassinsCreed.projectTags = [
	"trailers",
	"action",
	"sci-fi",
	"Assassins Creed",
	"tv",
];
assassinsCreed.projectVideos = ["209163244", "209163276"];
projects.push(assassinsCreed);

//___________________________________________________________________________________

let aVeryMurrayChristmas = new ProjectObject();
aVeryMurrayChristmas.projectTitle = "A Very Murray Christmas";
aVeryMurrayChristmas.projectText = "Editor / Motion Graphics";
aVeryMurrayChristmas.imgSrc = "images/aVeryMurrayChristmas.jpg";
aVeryMurrayChristmas.projectTags = [
	"comedy",
	"A Very Murray Christmas",
	"trailers",
];
aVeryMurrayChristmas.projectVideos = ["209141658", "209141623", "209141581"];
projects.push(aVeryMurrayChristmas);

//___________________________________________________________________________________

let boschS2 = new ProjectObject();
boschS2.projectTitle = "Bosch Season 2";
boschS2.projectText = "Editor / Motion Graphics";
boschS2.imgSrc = "images/boschSeason2.jpg";
boschS2.projectTags = [
	"action",
	"Bosch Season 2",
	"trailers",
	"tv",
];
boschS2.projectVideos = ["209163500", "209163424", "209163500"];
projects.push(boschS2);

//___________________________________________________________________________________

let dawnOfThePlanetOfTheApes = new ProjectObject();
dawnOfThePlanetOfTheApes.projectTitle = "Dawn of the Planet of the Apes";
dawnOfThePlanetOfTheApes.projectText = "Editor / Motion Graphics";
dawnOfThePlanetOfTheApes.imgSrc = "images/dawnOfThePlanetOfTheApes.jpg";
dawnOfThePlanetOfTheApes.projectTags = [
	"trailers",
	"action",
	"sci-fi",
	"Dawn of the Planet of the Apes",
	"tv",
];
dawnOfThePlanetOfTheApes.projectVideos = ["209163648", "209163616", "209163695", "20th"];
projects.push(dawnOfThePlanetOfTheApes);

//___________________________________________________________________________________

let dellTechnologiesWorld = new ProjectObject();
dellTechnologiesWorld.projectTitle = "Dell Technologies World";
dellTechnologiesWorld.projectText = "Editor / Motion Graphics";
dellTechnologiesWorld.imgSrc = "images/dellTechnologiesWorld.jpg";
dellTechnologiesWorld.projectTags = [
	"sizzle",
	"Dell Technologies World",
];
dellTechnologiesWorld.projectVideos = ["363467805", "363467702"];
projects.push(dellTechnologiesWorld);

//___________________________________________________________________________________

let eddieTheEagle = new ProjectObject();
eddieTheEagle.projectTitle = "Eddie The Eagle";
eddieTheEagle.projectText = "Editor";
eddieTheEagle.imgSrc = "images/eddieTheEagle.jpg";
eddieTheEagle.projectTags = [
	"trailers",
	"comedy",
	"historical",
	"Eddie The Eagle",
	"tv",
];
eddieTheEagle.projectVideos = ["209163863", "209163824"];
projects.push(eddieTheEagle);

//___________________________________________________________________________________

let extinction = new ProjectObject();
extinction.projectTitle = "Extinction";
extinction.projectText = "Editor";
extinction.imgSrc = "images/extinction.jpg";
extinction.projectTags = [
	"horror",
	"sci-fi",
	"extinction",
	"trailers",
];
extinction.projectVideos = ["279750518"];
projects.push(extinction);

//___________________________________________________________________________________

let fantasticBeasts = new ProjectObject();
fantasticBeasts.projectTitle = "Fantastic Beasts and Where to Find Them";
fantasticBeasts.projectText = "Editor";
fantasticBeasts.imgSrc = "images/fantasticBeasts.jpg";
fantasticBeasts.projectTags = [
	"trailers",
	"adventure",
	"Fantastic Beasts and Where to Find Them",
	"tv",
];
fantasticBeasts.projectVideos = ["209163920"];
projects.push(fantasticBeasts);

//___________________________________________________________________________________

let ifIStay = new ProjectObject();
ifIStay.projectTitle = "If I Stay";
ifIStay.projectText = "Editor / Motion Graphics";
ifIStay.imgSrc = "images/ifIStay.jpg";
ifIStay.projectTags = [
	"trailers",
	"drama",
	"romance",
	"ifIStay",
	"tv",
];
ifIStay.projectVideos = ["209163980"];
projects.push(ifIStay);

//___________________________________________________________________________________

let indigoSlateDesignLedThinking = new ProjectObject();
indigoSlateDesignLedThinking.projectTitle = "indigo slate Design Led Thinking";
indigoSlateDesignLedThinking.projectText = "Editor / Motion Graphics/ Voice Over";
indigoSlateDesignLedThinking.imgSrc = "images/indigoSlateDesignLedThinking.jpg";
indigoSlateDesignLedThinking.projectTags = [
	"voice over",
	"corporate",
	"indigo slate",
	"Design Led Thinking",
];
indigoSlateDesignLedThinking.projectVideos = ["475254162"];
projects.push(indigoSlateDesignLedThinking);

//___________________________________________________________________________________

let indigoSlateEverywhereExperiences = new ProjectObject();
indigoSlateEverywhereExperiences.projectTitle = "indigo slate Everywhere Experiences";
indigoSlateEverywhereExperiences.projectText = "Editor / Motion Graphics";
indigoSlateEverywhereExperiences.imgSrc = "images/indigoSlateEverywhereExperiences.jpg";
indigoSlateEverywhereExperiences.projectTags = [
	"corporate",
	"indigo slate",
	"Everywhere Experiences",
];
indigoSlateEverywhereExperiences.projectVideos = ["475255857"];
projects.push(indigoSlateEverywhereExperiences);

//___________________________________________________________________________________

let imagineCup21 = new ProjectObject();
imagineCup21.projectTitle = "Imagine Cup 2021";
imagineCup21.projectText = "Editor";
imagineCup21.imgSrc = "images/ImagineCup21.jpg";
imagineCup21.projectTags = [
	"corporate",
	"imagine cup 2021",
];
imagineCup21.projectVideos = ["569683335"];
projects.push(imagineCup21);

//___________________________________________________________________________________

let jackRyan = new ProjectObject();
jackRyan.projectTitle = "Jack Ryan Shadow Recruit";
jackRyan.projectText = "Editor";
jackRyan.imgSrc = "images/jackRyanShadowRecruit.jpg";
jackRyan.projectTags = [
	"trailers",
	"action",
	"Jack Ryan Shadow Recruit",
	"tv",
];
jackRyan.projectVideos = ["125547875"];
projects.push(jackRyan);

//___________________________________________________________________________________

let johnHenry = new ProjectObject();
johnHenry.projectTitle = "John Henry and the Statesmen";
johnHenry.projectText = "Editor / Motion Graphics";
johnHenry.imgSrc = "images/johnHenryAndTheStatesmen.jpg";
johnHenry.projectTags = [
	"drama",
	"historical",
	"John Henry and the Statesmen",
	"trailers",
];
johnHenry.projectVideos = ["312820873"];
projects.push(johnHenry);

//___________________________________________________________________________________

let joy = new ProjectObject();
joy.projectTitle = "joy";
joy.projectText = "Editor / Motion Graphics";
joy.imgSrc = "images/joy.jpg";
joy.projectTags = [
	"trailers",
	"historical",
	"drama",
	"joy",
	"tv",
];
joy.projectVideos = ["209164131", "209164107"];
projects.push(joy);

//___________________________________________________________________________________

let logan = new ProjectObject();
logan.projectTitle = "Logan";
logan.projectText = "Editor";
logan.imgSrc = "images/logan.jpg";
logan.projectTags = [
	"trailers",
	"drama",
	"action",
	"Logan",
	"tv",
	"awards",
];
logan.projectVideos = ["208255115", "208255125", "209509332", "209509303"];
logan.award = ["clio"];
projects.push(logan);

//___________________________________________________________________________________

let microsoft365Deployment = new ProjectObject();
microsoft365Deployment.projectTitle = "Microsoft 365 Deployment";
microsoft365Deployment.projectText = "Editor / Motion Graphics";
microsoft365Deployment.imgSrc = "images/microsoft365Deployment.jpg";
microsoft365Deployment.projectTags = [
	"corporate",
	"Microsoft 365 Deployment",
];
microsoft365Deployment.projectVideos = ["400813202"];
projects.push(microsoft365Deployment);

//___________________________________________________________________________________

let microsoft365MobileProductivity = new ProjectObject();
microsoft365MobileProductivity.projectTitle = "Microsoft M365 Mobile Productivity";
microsoft365MobileProductivity.projectText = "Editor / Motion Graphics/ Voice Over";
microsoft365MobileProductivity.imgSrc = "images/microsoft365MobileProductivity.jpg";
microsoft365MobileProductivity.projectTags = [
	"voice over",
	"drama",
	"corporate",
	"Microsoft M365 Mobile Productivity",
	"awards",
	"favorites",
];
microsoft365MobileProductivity.projectVideos = ["516839250"];
microsoft365MobileProductivity.award = ["tellyAwardBronze"]
projects.push(microsoft365MobileProductivity);

//___________________________________________________________________________________

let microsoft365PartnerVideos = new ProjectObject();
microsoft365PartnerVideos.projectTitle = "Microsoft M365 Partner Videos";
microsoft365PartnerVideos.projectText = "Editor / Motion Graphics";
microsoft365PartnerVideos.imgSrc = "images/microsoft365PartnerVideos.jpg";
microsoft365PartnerVideos.projectTags = [
	"corporate",
	"Microsoft M365 Partner Videos",
];
microsoft365PartnerVideos.projectVideos = ["518814473", "518815084", "518815191"];
projects.push(microsoft365PartnerVideos);

//___________________________________________________________________________________

let microsoftAIBDM = new ProjectObject();
microsoftAIBDM.projectTitle = "Microsoft AI BDM";
microsoftAIBDM.projectText = "Editor / Motion Graphics";
microsoftAIBDM.imgSrc = "images/microsoftAI-BDM.jpg";
microsoftAIBDM.projectTags = [
	"sizzle",
	"Microsoft AI BDM",
];
microsoftAIBDM.projectVideos = ["363462269"];
projects.push(microsoftAIBDM);

//___________________________________________________________________________________

let microsoftAIInService = new ProjectObject();
microsoftAIInService.projectTitle = "Microsoft AI In Service Episode 1";
microsoftAIInService.projectText = "Editor";
microsoftAIInService.imgSrc = "images/microsoftAIInService.jpg";
microsoftAIInService.projectTags = [
	"corporate",
	"Microsoft AI In Service",
];
microsoftAIInService.projectVideos = ["954063648"];
projects.push(microsoftAIInService);

//___________________________________________________________________________________

let microsoftAILoblaw = new ProjectObject();
microsoftAILoblaw.projectTitle = "Microsoft AI Loblaw";
microsoftAILoblaw.projectText = "Editor / Motion Graphics";
microsoftAILoblaw.imgSrc = "images/microsoftAI-Loblaw.jpg";
microsoftAILoblaw.projectTags = [
	"microsoft",
	"case study",
	"Microsoft AI Loblaw",
];
microsoftAILoblaw.projectVideos = ["363463375"];
projects.push(microsoftAILoblaw);

//___________________________________________________________________________________

let microsoftProjectHanover = new ProjectObject();
microsoftProjectHanover.projectTitle = "Microsoft Project Hanover";
microsoftProjectHanover.projectText = "Editor / Motion Graphics";
microsoftProjectHanover.imgSrc = "images/microsoftAIProjectHanover.jpg";
microsoftProjectHanover.projectTags = [
	"microsoft",
	"case study",
	"Microsoft Project Hanover",
];
microsoftProjectHanover.projectVideos = ["363461298"];
projects.push(microsoftProjectHanover);

//___________________________________________________________________________________

let microsoftAzureAD20Years = new ProjectObject();
microsoftAzureAD20Years.projectTitle = "Microsoft Azure AD 20 Years";
microsoftAzureAD20Years.projectText = "Editor / Motion Graphics";
microsoftAzureAD20Years.imgSrc = "images/microsoftAzureAD20Years.jpg";
microsoftAzureAD20Years.projectTags = [
	"corporate",
	"historical",
	"favorites",
	"Microsoft Azure AD 20 Years",
];
microsoftAzureAD20Years.projectVideos = ["518814623"];
projects.push(microsoftAzureAD20Years);

//___________________________________________________________________________________

let microsoftBuildingBuild = new ProjectObject();
microsoftBuildingBuild.projectTitle = "Building Build";
microsoftBuildingBuild.projectText = "Editor / Motion Graphics";
microsoftBuildingBuild.imgSrc = "images/microsoftBuildingBuild.jpg";
microsoftBuildingBuild.projectTags = [
	"corporate",
	"Building Build",
	"awards",
];
microsoftBuildingBuild.projectVideos = ["521752909"];
microsoftBuildingBuild.award = ["tellyAwardBronze"]
projects.push(microsoftBuildingBuild);

//___________________________________________________________________________________

let microsoftGOSHTeamUp = new ProjectObject();
microsoftGOSHTeamUp.projectTitle = "Microsoft GOSH Team Up";
microsoftGOSHTeamUp.projectText = "Editor";
microsoftGOSHTeamUp.imgSrc = "images/microsoftGOSHTeamUp.jpg";
microsoftGOSHTeamUp.projectTags = [
	"case study",
	"Microsoft GOSH Team Up",
];
microsoftGOSHTeamUp.projectVideos = ["475253473"];
projects.push(microsoftGOSHTeamUp);

//___________________________________________________________________________________

let microsoftSmartSpaces = new ProjectObject();
microsoftSmartSpaces.projectTitle = "Microsoft Smart Spaces";
microsoftSmartSpaces.projectText = "Editor / Motion Graphics";
microsoftSmartSpaces.imgSrc = "images/microsoftSmartSpaces.jpg";
microsoftSmartSpaces.projectTags = [
	"sizzle",
	"favorites",
	"Microsoft Smart Spaces",
];
microsoftSmartSpaces.projectVideos = ["518814848"];
projects.push(microsoftSmartSpaces);

//___________________________________________________________________________________

let microsoftBusinessCentral = new ProjectObject();
microsoftBusinessCentral.projectTitle = "Microsoft Business Central";
microsoftBusinessCentral.projectText = "Editor";
microsoftBusinessCentral.imgSrc = "images/microsoftBusinessCentral.jpg";
microsoftBusinessCentral.projectTags = [
	"corporate",
	"Microsoft Business Central",
];
microsoftBusinessCentral.projectVideos = ["954069967"];
projects.push(microsoftBusinessCentral);


//___________________________________________________________________________________

let xboxAdaptiveController = new ProjectObject();
xboxAdaptiveController.projectTitle = "Xbox Adaptive Controller";
xboxAdaptiveController.projectText = "Editor / Motion Graphics";
xboxAdaptiveController.imgSrc = "images/microsoftXboxAdaptiveController.jpg";
xboxAdaptiveController.projectTags = [
	"sizzle",
	"Xbox Adaptive Controller",
];
xboxAdaptiveController.projectVideos = ["363466498"];
projects.push(xboxAdaptiveController);

//___________________________________________________________________________________

let moneyHeistS2 = new ProjectObject();
moneyHeistS2.projectTitle = "Money Heist: Season 2";
moneyHeistS2.projectText = "Editor";
moneyHeistS2.imgSrc = "images/moneyHeistS2.jpg";
moneyHeistS2.projectTags = [
	"drama",
	"action",
	"Money Heist: Season 2",
	"trailers",
];
moneyHeistS2.projectVideos = ["279750491"];
projects.push(moneyHeistS2);

//___________________________________________________________________________________

let narcosMexico = new ProjectObject();
narcosMexico.projectTitle = "Narcos: Mexico";
narcosMexico.projectText = "Editor";
narcosMexico.imgSrc = "images/narcosMexico.jpg";
narcosMexico.projectTags = [
	"drama",
	"historical",
	"trailers",
	"awards",
];
narcosMexico.projectVideos = ["292769952"];
narcosMexico.award = ["clio"];
projects.push(narcosMexico);

//___________________________________________________________________________________

let narcosS1 = new ProjectObject();
narcosS1.projectTitle = "Narcos: Season 1";
narcosS1.projectText = "Editor";
narcosS1.imgSrc = "images/narcosSeason1.jpg";
narcosS1.projectTags = [
	"trailers",
	"drama",
	"historical",
	"Narcos: Season 1",
	"tv",
	"awards",
];
narcosS1.projectVideos = [
	"208256474",
	"208256554",
	"208257459",
	"208256456",
	"208257500",
	"208256444",
	"208256504",
	"208256434",
];
narcosS1.award = ["clio"];
projects.push(narcosS1);

//___________________________________________________________________________________

let narcosS2 = new ProjectObject();
narcosS2.projectTitle = "Narcos: Season 2";
narcosS2.projectText = "Editor";
narcosS2.imgSrc = "images/narcosSeason2.jpg";
narcosS2.projectTags = [
	"drama",
	"narcos season 2",
	"historical",
	"trailers",
	"tv",
	"awards",
	"favorites",
];
narcosS2.projectVideos = ["208770645", "208770547", "208770473"];
narcosS2.award = ["golden"];
projects.push(narcosS2);

//___________________________________________________________________________________

let narcosS3 = new ProjectObject();
narcosS3.projectTitle = "Narcos: Season 3";
narcosS3.projectText = "Editor / Motion Graphics";
narcosS3.imgSrc = "images/narcosSeason3.jpg";
narcosS3.projectTags = [
	"trailers",
	"drama",
	"historical",
	"Narcos Season 3",
	"tv",
];
narcosS3.projectVideos = ["279754111", "279753867", "279753924", "279753982"];
projects.push(narcosS3);

//___________________________________________________________________________________

let oculus = new ProjectObject();
oculus.projectTitle = "Oculus";
oculus.projectText = "Editor / Motion Graphics";
oculus.imgSrc = "images/oculus.jpg";
oculus.projectTags = [
	"trailers",
	"horror",
	"oculus",
	"tv",
];
oculus.projectVideos = ["209164279"];
projects.push(oculus);

//___________________________________________________________________________________

let ozarkS1 = new ProjectObject();
ozarkS1.projectTitle = "Ozark: Season 1";
ozarkS1.projectText = "Editor / Motion Graphics";
ozarkS1.imgSrc = "images/ozarkSeason1.jpg";
ozarkS1.projectTags = [
	"trailers",
	"drama",
	"Ozark: Season 1",
	"tv",
];
ozarkS1.projectVideos = ["272281344"];
projects.push(ozarkS1);

//___________________________________________________________________________________

let paccarFutureSales = new ProjectObject();
paccarFutureSales.projectTitle = "PACCAR Future Sales";
paccarFutureSales.projectText = "Editor / Motion Graphics";
paccarFutureSales.imgSrc = "images/paccarFutureSales.jpg";
paccarFutureSales.projectTags = [
	"corporate",
	"PACCAR Future Sales",
];
paccarFutureSales.projectVideos = ["475252039"];
projects.push(paccarFutureSales);

//___________________________________________________________________________________

let paperTowns = new ProjectObject();
paperTowns.projectTitle = "Paper Towns";
paperTowns.projectText = "Editor / Motion Graphics";
paperTowns.imgSrc = "images/paperTowns.jpg";
paperTowns.projectTags = [
	"trailers",
	"drama",
	"romance",
	"Paper Towns",
	"tv",
];
paperTowns.projectVideos = ["208253092", "208252719", "208252904", "208252887"];
projects.push(paperTowns);

//___________________________________________________________________________________

let peoplePlacesThings = new ProjectObject();
peoplePlacesThings.projectTitle = "People Places Things";
peoplePlacesThings.projectText = "Editor";
peoplePlacesThings.imgSrc = "images/peoplePlacesThings.jpg";
peoplePlacesThings.projectTags = [
	"drama",
	"comedy",
	"People Places Things",
	"trailers",
];
peoplePlacesThings.projectVideos = ["209164301"];
projects.push(peoplePlacesThings);

//___________________________________________________________________________________

let petesDragon = new ProjectObject();
petesDragon.projectTitle = "Pete's Dragon";
petesDragon.projectText = "Editor";
petesDragon.imgSrc = "images/petesDragon.jpg";
petesDragon.projectTags = [
	"trailers",
	"adventure",
	"family",
	"Pete's Dragon",
	"tv",
	"awards",
];
petesDragon.projectVideos = [
	"209164720",
	"209164565",
	"209164674",
	"209164510",
	"209164480",
	"209164530",
];
petesDragon.award = ["clio"];
projects.push(petesDragon);

//___________________________________________________________________________________

let powerRangers = new ProjectObject();
powerRangers.projectTitle = "Power Rangers";
powerRangers.projectText = "Editor / Motion Graphics";
powerRangers.imgSrc = "images/powerRangers.jpg";
powerRangers.projectTags = [
	"trailers",
	"action",
	"sci-fi",
	"Power Rangers",
	"tv",
];
powerRangers.projectVideos = ["209510220", "209510166"];
projects.push(powerRangers);

//___________________________________________________________________________________

let rampage = new ProjectObject();
rampage.projectTitle = "Rampage";
rampage.projectText = "Editor";
rampage.imgSrc = "images/rampage.jpg";
rampage.projectTags = [
	"trailers",
	"action",
	"sci-fi",
	"horror",
	"rampage",
	"tv",
	"awards",
];
rampage.projectVideos = ["272281886", "272282009", "272281838"];
rampage.award = ["clio"];
projects.push(rampage);

//___________________________________________________________________________________

let runnerRunner = new ProjectObject();
runnerRunner.projectTitle = "Runner Runner";
runnerRunner.projectText = "Editor / Motion Graphics";
runnerRunner.imgSrc = "images/runnerRunner.jpg";
runnerRunner.projectTags = [
	"trailers",
	"action",
	"drama",
	"Runner Runner",
	"tv",
];
runnerRunner.projectVideos = ["312819548"];
projects.push(runnerRunner);

//___________________________________________________________________________________

let sapConcurCustomerTrust = new ProjectObject();
sapConcurCustomerTrust.projectTitle = "SAP Concur Customer Trust";
sapConcurCustomerTrust.projectText = "Editor / Motion Graphics";
sapConcurCustomerTrust.imgSrc = "images/SAPConcurCustomerTrust.jpg";
sapConcurCustomerTrust.projectTags = [
	"corporate",
	"SAP Concur Customer Trust",
];
sapConcurCustomerTrust.projectVideos = ["363464400"];
projects.push(sapConcurCustomerTrust);

//___________________________________________________________________________________

let sapSizzle = new ProjectObject();
sapSizzle.projectTitle = "SAP Sizzle";
sapSizzle.projectText = "Editor / Motion Graphics";
sapSizzle.imgSrc = "images/sapSizzle.jpg";
sapSizzle.projectTags = [
	"sizzle",
	"SAP Sizzle",
	"indigo slate",
];
sapSizzle.projectVideos = ["525680252"];
projects.push(sapSizzle);

//___________________________________________________________________________________

let sevenBucksHoliday = new ProjectObject();
sevenBucksHoliday.projectTitle = "Seven Bucks Holiday";
sevenBucksHoliday.projectText = "Editor / Motion Graphics";
sevenBucksHoliday.imgSrc = "images/sevenBucksHoliday.jpg";
sevenBucksHoliday.projectTags = [
	"corporate",
	"Seven Bucks Holiday",
];
sevenBucksHoliday.projectVideos = ["312821683"];
projects.push(sevenBucksHoliday);

//___________________________________________________________________________________

let shazam = new ProjectObject();
shazam.projectTitle = "Shazam!";
shazam.projectText = "Editor";
shazam.imgSrc = "images/shazam.jpg";
shazam.projectTags = [
	"comedy",
	"action",
	"adventure",
	"shazam!",
	"trailers",
];
shazam.projectVideos = ["281502145"];
projects.push(shazam);

//___________________________________________________________________________________

let skypeMeetNow = new ProjectObject();
skypeMeetNow.projectTitle = "Skype Meet Now";
skypeMeetNow.projectText = "Editor / Motion Graphics";
skypeMeetNow.imgSrc = "images/skypeMeetNow.jpg";
skypeMeetNow.projectTags = [
	"corporate",
	"Skype Meet Now",
];
skypeMeetNow.projectVideos = ["475257653"];
projects.push(skypeMeetNow);

//___________________________________________________________________________________

let sonySpec = new ProjectObject();
sonySpec.projectTitle = "Sony Spec Ad";
sonySpec.projectText = "Editor / Motion Graphics";
sonySpec.imgSrc = "images/sonySpec.jpg";
sonySpec.projectTags = ["corporate", "Sony Spec Ad"];
sonySpec.projectVideos = ["668848427"];
projects.push(sonySpec);

//___________________________________________________________________________________

let theBoy = new ProjectObject();
theBoy.projectTitle = "The Boy";
theBoy.projectText = "Editor";
theBoy.imgSrc = "images/theBoy.jpg";
theBoy.projectTags = ["trailers", "horror", "The Boy", "tv"];
theBoy.projectVideos = ["209165016", "209164905", "209164975", "209164928"];
projects.push(theBoy);

//___________________________________________________________________________________

let theFinestHours = new ProjectObject();
theFinestHours.projectTitle = "The Finest Hours";
theFinestHours.projectText = "Editor";
theFinestHours.imgSrc = "images/theFinestHours.jpg";
theFinestHours.projectTags = [
	"trailers",
	"drama",
	"historical",
	"romance",
	"The Finest Hours",
	"tv",
	"awards",
];
theFinestHours.projectVideos = ["209510595", "209510549"];
theFinestHours.award = ["clio"];
projects.push(theFinestHours);

//___________________________________________________________________________________

let theGetDown = new ProjectObject();
theGetDown.projectTitle = "The Get Down";
theGetDown.projectText = "Editor";
theGetDown.imgSrc = "images/theGetDown.jpg";
theGetDown.projectTags = [
	"trailers",
	"drama",
	"historical",
	"romance",
	"The Get Down",
	"awards",
];
theGetDown.projectVideos = ["208769604"];
theGetDown.award = ["clio"];
projects.push(theGetDown);

//___________________________________________________________________________________

let theGreatWall = new ProjectObject();
theGreatWall.projectTitle = "The Great Wall";
theGreatWall.projectText = "Editor";
theGreatWall.imgSrc = "images/theGreatWall.jpg";
theGreatWall.projectTags = [
	"trailers",
	"action",
	"sci-fi",
	"The Great Wall",
	"tv",
];
theGreatWall.projectVideos = ["208768902"];
projects.push(theGreatWall);

//___________________________________________________________________________________

let theLongestRide = new ProjectObject();
theLongestRide.projectTitle = "The Longest Ride";
theLongestRide.projectText = "Editor / Motion Graphics";
theLongestRide.imgSrc = "images/theLongestRide.jpg";
theLongestRide.projectTags = [
	"trailers",
	"drama",
	"historical",
	"romance",
	"The Longest Ride",
	"tv",
];
theLongestRide.projectVideos = [
	"208767181",
	"208767145",
	"208767760",
	"208767783",
	"208768229",
	"208767210",
	"208767799",
	"208767812",
];
projects.push(theLongestRide);

//___________________________________________________________________________________

let theMazeRunner = new ProjectObject();
theMazeRunner.projectTitle = "The Maze Runner";
theMazeRunner.projectText = "Editor / Motion Graphics";
theMazeRunner.imgSrc = "images/theMazeRunner.jpg";
theMazeRunner.projectTags = [
	"trailers",
	"action",
	"sci-fi",
	"The Maze Runner",
	"tv",
];
theMazeRunner.projectVideos = ["209164210"];
projects.push(theMazeRunner);

//___________________________________________________________________________________

let theMazeRunnerScorchTrials = new ProjectObject();
theMazeRunnerScorchTrials.projectTitle = "The Maze Runner: Scorch Trials";
theMazeRunnerScorchTrials.projectText = "Editor / Motion Graphics";
theMazeRunnerScorchTrials.imgSrc = "images/theMazeRunnerScorchTrials.jpg";
theMazeRunnerScorchTrials.projectTags = [
	"trailers",
	"action",
	"sci-fi",
	"The Maze Runner: Scorch Trials",
	"tv",
];
theMazeRunnerScorchTrials.projectVideos = ["209164258"];
projects.push(theMazeRunnerScorchTrials);

//___________________________________________________________________________________

let theMountainBetweenUs = new ProjectObject();
theMountainBetweenUs.projectTitle = "The Mountain Between Us";
theMountainBetweenUs.projectText = "Editor";
theMountainBetweenUs.imgSrc = "images/theMountainBetweenUs.jpg";
theMountainBetweenUs.projectTags = [
	"trailers",
	"drama",
	"romance",
	"The Mountain Between Us",
	"tv",
];
theMountainBetweenUs.projectVideos = ["279757097"];
projects.push(theMountainBetweenUs);

//___________________________________________________________________________________

let theSecretLifeofWalterMitty = new ProjectObject();
theSecretLifeofWalterMitty.projectTitle = "The Secret Life of Walter Mitty";
theSecretLifeofWalterMitty.projectText = "Editor / Motion Graphics";
theSecretLifeofWalterMitty.imgSrc = "images/theSecretLifeofWalterMitty.jpg";
theSecretLifeofWalterMitty.projectTags = [
	"trailers",
	"adventure",
	"drama",
	"romance",
	"comedy",
	"The Secret Life of Walter Mitty",
	"tv",
	"awards",
];
theSecretLifeofWalterMitty.projectVideos = ["208428637", "208428618"];
theSecretLifeofWalterMitty.award = ["clio"];
projects.push(theSecretLifeofWalterMitty);

//___________________________________________________________________________________

let theWolverine = new ProjectObject();
theWolverine.projectTitle = "The Wolverine";
theWolverine.projectText = "Editor / Motion Graphics";
theWolverine.imgSrc = "images/theWolverine.jpg";
theWolverine.projectTags = [
	"trailers",
	"action",
	"sci-fi",
	"The Wolverine",
	"tv",
	"awards",
];
theWolverine.projectVideos = ["208427854", "208427841"];
theWolverine.award = ["clio"];
projects.push(theWolverine);

//___________________________________________________________________________________

let valveTheInternational = new ProjectObject();
valveTheInternational.projectTitle = "Valve The International 2019";
valveTheInternational.projectText = "Editor / Motion Graphics";
valveTheInternational.imgSrc = "images/valveTheInternational.jpg";
valveTheInternational.projectTags = [
	"case study",
	"Valve The International 2019",
];
valveTheInternational.projectVideos = ["363464976", "363465012", "363465063"];
projects.push(valveTheInternational);

//___________________________________________________________________________________

let xMenDaysOfFuturePast = new ProjectObject();
xMenDaysOfFuturePast.projectTitle = "Xmen Days of Future Past";
xMenDaysOfFuturePast.projectText = "Editor / Motion Graphics";
xMenDaysOfFuturePast.imgSrc = "images/xMenDaysOfFuturePast.jpg";
xMenDaysOfFuturePast.projectTags = [
	"trailers",
	"action",
	"sci-fi",
	"Xmen Days of Future Past",
	"tv",
	"awards",
];
xMenDaysOfFuturePast.projectVideos = [
	"208222198",
	"208222240",
	"208222173",
	"208222253",
	"208222158",
];
xMenDaysOfFuturePast.award = ["clio"];
projects.push(xMenDaysOfFuturePast);

//___________________________________________________________________________________

let woodinvilleWhiskey = new ProjectObject();
woodinvilleWhiskey.projectTitle = "Woodinville Whiskey Series";
woodinvilleWhiskey.projectText = "Editor / Motion Graphics";
woodinvilleWhiskey.imgSrc = "images/Woodinville Whiskey.jpg";
woodinvilleWhiskey.projectTags = [
	"case study",
	"Woodinville Whiskey",
	"awards",
	"favorites",
];
woodinvilleWhiskey.projectVideos = [
	"834208612",
	"834208586",
	"834208628",
	"834208563",
	"834208547",
	"834208533",
];
woodinvilleWhiskey.award = ["tellyAwardBronze"];
projects.push(woodinvilleWhiskey);

//___________________________________________________________________________________

let worstRoommateEver = new ProjectObject();
worstRoommateEver.projectTitle = "Worst Roommate Ever";
worstRoommateEver.projectText = "Editor";
worstRoommateEver.imgSrc = "images/Worst Roommate Ever.jpg";
worstRoommateEver.projectTags = [
	"historical",
	"trailers",
	"Worst Roommate Ever Season 1",
	"favorites",
];
worstRoommateEver.projectVideos = [
	"834208654",
];
worstRoommateEver.award = [];
projects.push(worstRoommateEver);

//___________________________________________________________________________________

let homeTeam = new ProjectObject();
homeTeam.projectTitle = "Home Team";
homeTeam.projectText = "Editor";
homeTeam.imgSrc = "images/Home Team.jpg";
homeTeam.projectTags = [
	"comedy",
	"trailers",
	"Home Team",
];
homeTeam.projectVideos = [
	"834209223",
];
homeTeam.award = [];
projects.push(homeTeam);

//___________________________________________________________________________________

let krakenHolidayCommercial = new ProjectObject();
krakenHolidayCommercial.projectTitle = "Kraken Holiday Commercial";
krakenHolidayCommercial.projectText = "Editor ";
krakenHolidayCommercial.imgSrc = "images/Kraken Holiday Commercial.jpg";
krakenHolidayCommercial.projectTags = [
	"corporate",
	"tv",
	"Kraken Holiday Commercial",
	"favorites",
];
krakenHolidayCommercial.projectVideos = [
	"834209114",
];
krakenHolidayCommercial.award = [];
projects.push(krakenHolidayCommercial);

//___________________________________________________________________________________

let theClausFamily2 = new ProjectObject();
theClausFamily2.projectTitle = "The Claus Family 2";
theClausFamily2.projectText = "Editor";
theClausFamily2.imgSrc = "images/The Claus Family 2.jpg";
theClausFamily2.projectTags = [
	"trailers",
	"The Claus Family 2",
];
theClausFamily2.projectVideos = [
	"834209245",
];
theClausFamily2.award = [];
projects.push(theClausFamily2);


//___________________________________________________________________________________

let aForceForCampaign = new ProjectObject();
aForceForCampaign.projectTitle = "F5 A Force For";
aForceForCampaign.projectText = "Editor / Motion Graphics";
aForceForCampaign.imgSrc = "images/F5 A Force For.jpg";
aForceForCampaign.projectTags = [
	"corporate",
	"tv",
	"F5 A Force For Campaign",
	"favorites",
];
aForceForCampaign.projectVideos = [
	"834210361",
	"834209926",
];
aForceForCampaign.award = [];
projects.push(aForceForCampaign);

//___________________________________________________________________________________

let microsoftGameChangers = new ProjectObject();
microsoftGameChangers.projectTitle = "Microsoft Game Changers";
microsoftGameChangers.projectText = "Editor / Motion Graphics";
microsoftGameChangers.imgSrc = "images/Microsoft Game Changers.jpg";
microsoftGameChangers.projectTags = [
	"sizzle",
	"tv",
	"Microsoft Game Changers",
	"favorites",
];
microsoftGameChangers.projectVideos = [
	"834210474",
	"834210450",
];
microsoftGameChangers.award = [];
projects.push(microsoftGameChangers);

//___________________________________________________________________________________

let alexaShopping = new ProjectObject();
alexaShopping.projectTitle = "Amazon Alexa Shopping Design";
alexaShopping.projectText = "Editor";
alexaShopping.imgSrc = "images/amazonAlexaDesignShopping.jpg";
alexaShopping.projectTags = [
	"case study",
	"online",
	"Amazon Alexa Shopping Design",
];
alexaShopping.projectVideos = [
	"838420916",
];
alexaShopping.award = [];
projects.push(alexaShopping);


//___________________________________________________________________________________

let bumbershoot23 = new ProjectObject();
bumbershoot23.projectTitle = "Bumbershoot 2023";
bumbershoot23.projectText = "Editor / Motion Graphics";
bumbershoot23.imgSrc = "images/bumbershoot23.jpg";
bumbershoot23.projectTags = [
	"sizzle",
	"music",
	"tv",
	"Bumbershoot",
];
bumbershoot23.projectVideos = [
	"871934514",
	"859059745",
	"859061840"
];
bumbershoot23.award = [];
projects.push(bumbershoot23);


//___________________________________________________________________________________

let github24Announce = new ProjectObject();
github24Announce.projectTitle = "Github 2024 Announcement";
github24Announce.projectText = "Editor / Motion Graphics";
github24Announce.imgSrc = "images/Github_Announce.jpg";
github24Announce.projectTags = [
	"corporate",
	"Github",
	"favorites",
];
github24Announce.projectVideos = [
	"890902462",
];
github24Announce.award = [];
projects.push(github24Announce);


//___________________________________________________________________________________

let signalAnthem = new ProjectObject();
signalAnthem.projectTitle = "Signal";
signalAnthem.projectText = "Editor / Motion Graphics";
signalAnthem.imgSrc = "images/Signal_Anthem.jpg";
signalAnthem.projectTags = [
	"corporate",
	"Signal",
	"favorites",
];
signalAnthem.projectVideos = [
	"890901848",
	"954051592",
	"954051500",
	"954051422",
	"954051327",
	"954051245",
	"954051170",
	"954051074",
	"954050976"
];
signalAnthem.award = [];
projects.push(signalAnthem);


//___________________________________________________________________________________

let sunoLaunchSpot = new ProjectObject();
sunoLaunchSpot.projectTitle = "Suno.ai Launch Spot";
sunoLaunchSpot.projectText = "Editor / Motion Graphics";
sunoLaunchSpot.imgSrc = "images/sunoLaunchSpot.jpg";
sunoLaunchSpot.projectTags = [
	"corporate",
	"Suno",
];
sunoLaunchSpot.projectVideos = [
	"953019792",
];
sunoLaunchSpot.award = [];
projects.push(sunoLaunchSpot);

//___________________________________________________________________________________

let microsoftYesWay = new ProjectObject();
microsoftYesWay.projectTitle = "Microsoft Yes Way";
microsoftYesWay.projectText = "Editor / Motion Graphics";
microsoftYesWay.imgSrc = "images/microsoftYesWay.jpg";
microsoftYesWay.projectTags = [
	"sizzle",
	"Microsoft",
];
microsoftYesWay.projectVideos = [
	"953016867",
];
microsoftYesWay.award = [];
projects.push(microsoftYesWay);

//___________________________________________________________________________________

let officialXboxPodcast = new ProjectObject();
officialXboxPodcast.projectTitle = "Updates on the Xbox Business | Official Xbox Podcast";
officialXboxPodcast.projectText = "Editor";
officialXboxPodcast.imgSrc = "images/officialXboxPodcast.jpg";
officialXboxPodcast.projectTags = [
	"corporate",
	"gaming",
	"Xbox",
];
officialXboxPodcast.projectVideos = [
	"953022941",
];
officialXboxPodcast.award = [];
projects.push(officialXboxPodcast);


//___________________________________________________________________________________

let pokemonTCGLive = new ProjectObject();
pokemonTCGLive.projectTitle = "Pokémon TCG Live: Season 6 Trailer";
pokemonTCGLive.projectText = "Editor";
pokemonTCGLive.imgSrc = "images/pokemonTCGLive.jpg";
pokemonTCGLive.projectTags = [
	"corporate",
	"gaming",
	"Pokemon",
	"favorites",
];
pokemonTCGLive.projectVideos = [
	"953323612",
];
pokemonTCGLive.award = [];
projects.push(pokemonTCGLive);

//___________________________________________________________________________________

let sentinelOnePurpleAI = new ProjectObject();
sentinelOnePurpleAI.projectTitle = "SentinelOne Purple AI";
sentinelOnePurpleAI.projectText = "Editor / Voice Over";
sentinelOnePurpleAI.imgSrc = "images/sentinelOnePurpleAI.jpg";
sentinelOnePurpleAI.projectTags = [
	"corporate",
	"voice over",
	"SentinelOne",
];
sentinelOnePurpleAI.projectVideos = [
	"954048620",
];
sentinelOnePurpleAI.award = [];
projects.push(sentinelOnePurpleAI);


//___________________________________________________________________________________

let xDefiant = new ProjectObject();
xDefiant.projectTitle = "Ubisoft: XDefiant";
xDefiant.projectText = "Editor";
xDefiant.imgSrc = "images/xDefiant.jpg";
xDefiant.projectTags = [
	"gaming",
	"xDefiant",
	"favorites",
];
xDefiant.projectVideos = [
	"954053576",
];
xDefiant.award = [];
projects.push(xDefiant);


//___________________________________________________________________________________

let pimcoCaseStudy = new ProjectObject();
pimcoCaseStudy.projectTitle = "Microsoft PIMCO Case Study";
pimcoCaseStudy.projectText = "Editor";
pimcoCaseStudy.imgSrc = "images/microsoftPIMCOCaseStudy.jpg";
pimcoCaseStudy.projectTags = [
	"case study",
	"microsoft",
	"PIMCO",
];
pimcoCaseStudy.projectVideos = [
	"1055277060",
];
pimcoCaseStudy.award = [];
projects.push(pimcoCaseStudy);


//___________________________________________________________________________________

let MCAPSStart2022Sizzle = new ProjectObject();
MCAPSStart2022Sizzle.projectTitle = "MCAPS Start 2022 Opening Keynote";
MCAPSStart2022Sizzle.projectText = "Editor / Motion Graphics";
MCAPSStart2022Sizzle.imgSrc = "images/MCAPSStart2022Sizzle.jpg";
MCAPSStart2022Sizzle.projectTags = [
	"sizzle",
	"microsoft",
	"MCAPS Start",
];
MCAPSStart2022Sizzle.projectVideos = [
	"1107881480",
];
MCAPSStart2022Sizzle.award = [];
projects.push(MCAPSStart2022Sizzle);

//___________________________________________________________________________________

let MSEventsSizzle = new ProjectObject();
MSEventsSizzle.projectTitle = "MS Events Sizzle";
MSEventsSizzle.projectText = "Editor / Motion Graphics";
MSEventsSizzle.imgSrc = "images/MSEventsSizzle.jpg";
MSEventsSizzle.projectTags = [
	"sizzle",
	"microsoft",
	"MS Events Sizzle",
];
MSEventsSizzle.projectVideos = [
	"1107882945",
];
MSEventsSizzle.award = [];
projects.push(MSEventsSizzle);

//___________________________________________________________________________________

let MSIgnite2024Sizzle = new ProjectObject();
MSIgnite2024Sizzle.projectTitle = "2024 MS Ignite Customer Sizzle";
MSIgnite2024Sizzle.projectText = "Editor / Motion Graphics";
MSIgnite2024Sizzle.imgSrc = "images/MSIgnite2024Sizzle.jpg";
MSIgnite2024Sizzle.projectTags = [
	"sizzle",
	"microsoft",
	"Ignite 24",
];
MSIgnite2024Sizzle.projectVideos = [
	"1107883097",
];
MSIgnite2024Sizzle.award = [];
projects.push(MSIgnite2024Sizzle);


//___________________________________________________________________________________

let zetaTVCampaign = new ProjectObject();
zetaTVCampaign.projectTitle = "ZETA TV Campaign";
zetaTVCampaign.projectText = "Editor / Motion Graphics";
zetaTVCampaign.imgSrc = "images/zetaTVCampaign.jpg";
zetaTVCampaign.projectTags = [
	"corporate",
	"ZETA",
	"TV Campaign",
	"favorites",
];
zetaTVCampaign.projectVideos = [
	"1107881782",
	"1107882485",
	"1107881533",
	"1107882229",
];
zetaTVCampaign.award = [];
projects.push(zetaTVCampaign);


//___________________________________________________________________________________

let MCAPSStart2024Sizzle = new ProjectObject();
MCAPSStart2024Sizzle.projectTitle = "MCAPS Start 2024 Opening Keynote";
MCAPSStart2024Sizzle.projectText = "Editor / Motion Graphics";
MCAPSStart2024Sizzle.imgSrc = "images/MCAPSStart2024Sizzle.jpg";
MCAPSStart2024Sizzle.projectTags = [
	"sizzle",
	"microsoft",
	"MCAPS Start",
];
MCAPSStart2024Sizzle.projectVideos = [
	"1107949909",
];
MCAPSStart2024Sizzle.award = [];
projects.push(MCAPSStart2024Sizzle);


//___________________________________________________________________________________

let CISOEventSizzle = new ProjectObject();
CISOEventSizzle.projectTitle = "CISO Event Sizzle Video";
CISOEventSizzle.projectText = "Editor / Motion Graphics";
CISOEventSizzle.imgSrc = "images/CISOEventSizzle.jpg";
CISOEventSizzle.projectTags = [
	"sizzle",
	"microsoft",
	"CISO Event",
];
CISOEventSizzle.projectVideos = [
	"1107914826",
];
CISOEventSizzle.award = [];
projects.push(CISOEventSizzle);



//___________________________________________________________________________________

let MSBuild2025Highlights = new ProjectObject();
MSBuild2025Highlights.projectTitle = "MS BUILD 25 Highlight Video";
MSBuild2025Highlights.projectText = "Editor / Motion Graphics";
MSBuild2025Highlights.imgSrc = "images/MSBuild2025Highlights.jpg";
MSBuild2025Highlights.projectTags = [
	"sizzle",
	"microsoft",
	"Build 2025",
];
MSBuild2025Highlights.projectVideos = [
	"1107948642",
];
MSBuild2025Highlights.award = [];
projects.push(MSBuild2025Highlights);


//___________________________________________________________________________________

let MCAPSStart2025Sizzle = new ProjectObject();
MCAPSStart2025Sizzle.projectTitle = "MCAPS Start 25 Keynote Video";
MCAPSStart2025Sizzle.projectText = "Editor / Motion Graphics";
MCAPSStart2025Sizzle.imgSrc = "images/MCAPSStart2025Sizzle.jpg";
MCAPSStart2025Sizzle.projectTags = [
	"sizzle",
	"MCAPS Start 2025",
	"microsoft",
	"favorites",
];
MCAPSStart2025Sizzle.projectVideos = [
	"1107949483",
];
MCAPSStart2024Sizzle.award = [];
projects.push(MCAPSStart2025Sizzle);

//___________________________________________________________________________________

let MS50YearsOfPartnershipSizzle = new ProjectObject();
MS50YearsOfPartnershipSizzle.projectTitle = "MS 50 Years of Partnership Sizzle";
MS50YearsOfPartnershipSizzle.projectText = "Editor / Motion Graphics";
MS50YearsOfPartnershipSizzle.imgSrc = "images/MS50YearsOfPartnershipSizzle.jpg";
MS50YearsOfPartnershipSizzle.projectTags = [
	"sizzle",
	"50 Years of Partnership",
	"microsoft",
];
MS50YearsOfPartnershipSizzle.projectVideos = [
	"1107945826",
];
MS50YearsOfPartnershipSizzle.award = [];
projects.push(MS50YearsOfPartnershipSizzle);


//___________________________________________________________________________________

let AIOnTheGoSeries = new ProjectObject();
AIOnTheGoSeries.projectTitle = "AI On The Go Series";
AIOnTheGoSeries.projectText = "Editor / Motion Graphics";
AIOnTheGoSeries.imgSrc = "images/AIOnTheGoSeries.jpg";
AIOnTheGoSeries.projectTags = [
	"series",
	"corporate",
	"AI On The Go",
	"microsoft",
];
AIOnTheGoSeries.projectVideos = [
	"1107925003",
	"1107935028",
	"1107944373"
];
AIOnTheGoSeries.award = [];
projects.push(AIOnTheGoSeries);


//___________________________________________________________________________________

let AIOnTheGoComedySeries = new ProjectObject();
AIOnTheGoComedySeries.projectTitle = "AI On The Go Comedy Series";
AIOnTheGoComedySeries.projectText = "Editor / Motion Graphics";
AIOnTheGoComedySeries.imgSrc = "images/AIOnTheGoComedySeries.jpg";
AIOnTheGoComedySeries.projectTags = [
	"series",
	"comedy",
	"corporate",
	"AI On The Go Comedy",
	"microsoft",
];
AIOnTheGoComedySeries.projectVideos = [
	"1107923690",
];
AIOnTheGoComedySeries.award = [];
projects.push(AIOnTheGoComedySeries);

//___________________________________________________________________________________

let keithMercierSessionVideo = new ProjectObject();
keithMercierSessionVideo.projectTitle = "MS Keith Mercier Session Video";
keithMercierSessionVideo.projectText = "Editor / Motion Graphics";
keithMercierSessionVideo.imgSrc = "images/keithMercierSessionVideo.jpg";
keithMercierSessionVideo.projectTags = [
	"sizzle",
	"Keith Mercier Session Video",
	"microsoft",
];
keithMercierSessionVideo.projectVideos = [
	"1107945724",
];
keithMercierSessionVideo.award = [];
projects.push(keithMercierSessionVideo);

//___________________________________________________________________________________

let googleGeminiMusicVideo = new ProjectObject();
googleGeminiMusicVideo.projectTitle = "Google Gemini Music Video";
googleGeminiMusicVideo.projectText = "Editor / Motion Graphics";
googleGeminiMusicVideo.imgSrc = "images/googleGeminiMusicVideo.jpg";
googleGeminiMusicVideo.projectTags = [
	"corporate",
	"favorites",
	"Google Gemini Music Video",
	"google",
];
googleGeminiMusicVideo.projectVideos = [
	"1109091992",
];
googleGeminiMusicVideo.award = [];
projects.push(googleGeminiMusicVideo);


let tags = {
	favorites: [], sizzle: [], "case study": [],corporate:[], trailers: [], awards: [],
}


/* Randomize array in-place using Durstenfeld shuffle algorithm */
function shuffleArray(array) {
	for (var i = array.length - 1; i > 0; i--) {
		var j = Math.floor(Math.random() * (i + 1));
		var temp = array[i];
		array[i] = array[j];
		array[j] = temp;
	}
}

//take the main projects array and break it up into seperate tag based arrays
projects.map((project) => {
	for (let i = 0; i <= project.projectTags.length; i++) {
		if (tags.hasOwnProperty(project.projectTags[i])) {
			tags[project.projectTags[i]].push(project)
		}
	}

})

//go through each of the tag catagories and shuffle them
Object.keys(tags).map((tag) => {
	shuffleArray(tags[tag])
})


export { tags, projects };
